export default __webpack_public_path__ + "static/media/Rare__xvid.b478551e.mp4";